// Utility functions for handling @mentions

// Import and re-export from userService
import { getAllUsers, getUserByUsername } from '../services/userService';

// Extract username from email (before @)
export const getUsername = (email) => {
  return email.split('@')[0];
};

// Parse mentions from text and return array of usernames
export const parseMentions = (text) => {
  const mentionRegex = /@([a-zA-Z0-9._-]+)/g;
  const mentions = [];
  let match;
  
  while ((match = mentionRegex.exec(text)) !== null) {
    const username = match[1];
    if (!mentions.includes(username)) {
      mentions.push(username);
    }
  }
  
  return mentions;
};

// Re-export for backwards compatibility
export { getAllUsers };

// Re-export getUserByUsername as findUserByUsername
export const findUserByUsername = getUserByUsername;

// Convert mentions in text to formatted mentions (for display)
export const formatMentionsInText = (text) => {
  const mentionRegex = /@([a-zA-Z0-9._-]+)/g;
  return text.replace(mentionRegex, '<span class="mention">@$1</span>');
};

// Validate if a username exists
export const validateMentions = async (mentionedUsernames) => {
  const validMentions = [];
  const invalidMentions = [];
  
  for (const username of mentionedUsernames) {
    const user = await findUserByUsername(username);
    if (user) {
      validMentions.push(user);
    } else {
      invalidMentions.push(username);
    }
  }
  
  console.log('mentionUtils: Validated mentions:', { validMentions, invalidMentions });
  return { validMentions, invalidMentions };
};